<template>
  <div v-if="$store.getters.hasPermission(['All','Web'])">
    <el-col
      v-for="file in files"
      :key="file.name"
      :xs="24"
      :sm="12"
      :md="24"
    >
      <el-card
        shadow="hover"
        class="box-card"
        :body-style="{ padding: '0px' }"
      >
        <div
          slot="header"
          class="clearfix"
        >
          <span>{{ file.title }}</span>
        </div>
        <div style="padding:8px;">
          <el-upload
            style="width:100%"
            drag
            :show-file-list="false"
            :http-request="uploadFile"
            :name="file.name"
            action="/api/v1/announcements/upload"
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div
              slot="tip"
              class="el-upload__tip"
            >
              PDF files only
            </div>
          </el-upload>
          <span
            v-if="file.data"
            style="font-size: 11px; color: #A9A9A9;"
          >
            Last Modified: {{ file.data.last_modified }}
          </span>
          <span
            v-else
            style="font-size: 11px; color: #A9A9A9;"
          >
            Not Available
          </span>
        </div>
      </el-card>
    </el-col>
  </div>
</template>
<style lang="scss">
.el-upload{
 .el-upload-dragger {
    width: 100%;
  }
}
</style>
<script>
import {mapFields} from 'vuex-map-fields';

export default {
    computed: {
        ...mapFields([
            'user',
            'files'
        ])
    },
    mounted () {
        if (!this.files[0].data)
            this.getFileInfo();
    },
    methods: {
        uploadFile (param) {
            const data = new FormData();
            data.append('file', param.file, param.name);
            data.append('name', param.filename);
            this.axios.post('/api/v1/announcements/upload', data,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                var temp = this.files.find((file) => file.name.includes(param.filename));
                if (temp.data != null) {
                    this.$set(temp.data, 'last_modified', response.data.last_modified);
                } else {
                    this.$set(temp, 'data', response.data);
                }
                this.$message({
                    showClose: true,
                    message: 'File upload successful',
                    type: 'success'
                });
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if (err.response) {
                    terr = err.response.data.errors;
                }
                this.$message({
                    showClose: true,
                    message: terr,
                    type: 'error'
                });
            });
        },
        getFileInfo () {
            this.files.forEach((file) => {
                var route = '/api/v1/f/pdf/' + file.name + '.pdf/metadata';
                this.axios.get(route,
                    {
                        headers: {'Content-Type': 'application/json'},
                        credentials: 'same-origin'
                    }).then((response) => {
                    this.$set(file, 'data', response.data);
                }).catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: 'No ' + file.title + ' available.',
                        type: 'error'
                    });
                });
            });
        }
    }
}
</script>
